import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  DATE_PICKER_FORMAT,
  DATE_PICKER_MAX_CALENDAR_DATE,
  DATE_PICKER_MIN_CALENDAR_DATE,
} from "../datePickerFormats";
import { DatePickerLocalizationProvider } from "../useDatePickerLocalization";

export default function CustomDatePicker(props: any) {
  const {
    format = DATE_PICKER_FORMAT,
    slotProps,
    minDate,
    maxDate,
    ...restProps
  } = props;

  return (
    <DatePickerLocalizationProvider>
      <DatePicker
        {...restProps}
        minDate={minDate !== undefined ? minDate : DATE_PICKER_MIN_CALENDAR_DATE}
        maxDate={maxDate !== undefined ? maxDate : DATE_PICKER_MAX_CALENDAR_DATE}
        format={format}
        slotProps={{
          ...slotProps,
          actionBar: {
            actions: ["today", "clear"],
            ...slotProps?.actionBar,
          },
        }}
      />
    </DatePickerLocalizationProvider>
  );
}
